module.exports = __webpack_public_path__ + "img/saude2.44ecb73e.svg";